import { Component, Inject, OnInit } from '@angular/core';
import { ApiHelper } from 'src/app/core/service/api.helper';
import { ApiEndPoints } from 'src/app/core/constants';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SortingService } from 'src/app/core/service/sorting.service';
import { TaskService } from 'src/app/core/service/task.service';
import { ImageCropComponent } from 'src/app/shared/components/image-crop/image-crop.component';
import { dataformatorService } from 'src/app/core/service/dataformator.service';

import { ImageViewerComponent } from 'src/app/shared/components/image-viewer/image-viewer.component';
import formatTitle from 'src/app/core/helper/title-formatter.helper';
import { FileuploadService } from 'src/app/core/service/fileupload.service';
import { Validators, AbstractControl, ValidationErrors} from '@angular/forms'

import { Moment } from 'moment';
import * as moment from 'moment'; 
import { MatDatepicker } from '@angular/material/datepicker';

declare var $: any;

@Component({
  selector: 'app-profile-view',
  templateUrl: './profile-view.component.html',
  styleUrls: ['./profile-view.component.scss'],
})
export class ProfileViewComponent implements OnInit {
 
  locationDisplay :string = "";
  locationSuggestions: any[] = [];
  debounceTimer: any;

  startAt = new Date(new Date().setFullYear(new Date().getFullYear() - 12))
  imageChangedEvent: any;
  croppedImage: any;
  userDetails: any;
  hide!: boolean;
  hideArray = ['email'];

  canEdit: boolean = false;
  dialougBoxConfig: any;

  recordDetails: any;
  fileUpload: FormGroup;
  spinner: boolean = false;

  addForm: FormGroup;

  recordAddInfo: any = {
    courseAdd: false,
    projectAdd: false,
    achievementAdd: false,
    networkAdd: false,
    languageAdd: false,
    roleAdd: false,
    recommendationAdd: false,
  };

  recordInfo: any = {};
  updateProfile: FormGroup;
  profileEdit: boolean = false;
  session: any;
  currentEditCourse: any;

  config: any = {
    industryRole: {
      selectArray: [],
      formControlNames: 'industryRole',
    },
    languages: {
      selectArray: [],
      formControlNames: 'languages',
    },
  };
  profileId: string = '';

  formatTitle = formatTitle;

  filesArray: File[] = [];
  userProjectImage: File | string = '';
  userProjectPreviewImage!: string;
  previewImages: string[] = [];
  removeRecordImage: boolean = false;
  languages : string[] = [];
  roleLists: string[] = [];
  /*

    defaultText = 'Select a month';
  minDate: string;
  maxDate: string;

 const minDateObj = new Date();
    minDateObj.setFullYear(minDateObj.getFullYear() - 1);
    this.minDate = this.formatDateV3(minDateObj);

    // Set max date to current month
    const maxDateObj = new Date();
    this.maxDate = this.formatDateV3(maxDateObj);


  private formatDateV3(date: Date): string {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
      2,
      '0'
    )}`;
  }

  html--
  [min]="minDate" [max]="maxDate"

*/

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiHelper: ApiHelper,
    private activateRoute: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    // public nxtDailog : Dialog ,
    private formBuilder: FormBuilder,
    private sorting: SortingService,
    private taskService: TaskService,
    public dataFormator: dataformatorService,
    private fileUploadService: FileuploadService,
  ) {
    this.userDetails = {};
    this.canEdit = false;
    this.fileUpload = this.formBuilder.group({
      file: [null],
    });

    this.addForm = this.editForm();

    this.updateProfile = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      email: [''],
      gender: [''],
      socialMediaLinks: [''],
      bio: [''],
      dob: [''],
      location: this.formBuilder.group({
         city: [''],
         country: [''],
      }),
      industryRole: [],
      languages: [],
    });

    this.apiHelper
            .post({ type: "languages"}, ApiEndPoints.masterFind)
            .subscribe((response) => {
              if (!this.isEmpty(response.data)) {
                this.languages = this.sorting.sortArrayAlphabetically(response.data[0].data);
              }
            });

    this.apiHelper
            .post({ type: "roles"}, ApiEndPoints.masterFind)
            .subscribe((response) => {
              if (!this.isEmpty(response.data)) {
                this.roleLists = this.sorting.sortArrayAlphabetically(response.data[0].data);
              }
            });
  }

  isEmpty(data: any): boolean {
    if (!data || !Array.isArray(data)) {
      return true;
    }
    return data.length === 0;
  }

  editForm() {
    return this.formBuilder.group({
      profileId: [null],
      string1: [null, [Validators.required]],
      string2: [null],
      string3: [null],
      string4: [null,linkValidator],
      date1: [null, [Validators.required, projDateValidator]],
      date2: [null, [Validators.required, projDateValidator]],
      name: [null],
      text1: [null],
      json1: [null],
      file: [null],
    });
  }

  pop: boolean = false;

  ngOnInit(): void {
    this.activateRoute.params.subscribe((params) => {
      this.canEdit = false;
      let id = params['id'];

      this.apiHelper
        .post({ id: id }, ApiEndPoints.profileGet)
        .subscribe((response) => {
          this.userDetails = response.data;
          if(this.userDetails?.location?.city && this.userDetails?.location?.country){
            this.locationDisplay = `${this.userDetails.location.city}, ${this.userDetails.location.country}`;
            }
          this.config['languages'].selectArray =
            this.userDetails.languages || [];

          this.config['industryRole'].selectArray =
            this.userDetails.industryRole || [];

          this.recordDetails = this.userDetails.records.map((item: any) => ({
            ...item,
            isEditMode: false,
          }));
          this.sortByDate(this.recordDetails);
          this.hide = this.checkForVisibiliy('email');
          this.recordInfo = this.categorizeByKey(this.recordDetails, 'name');
        });
      let userSessionString: any = localStorage.getItem('session');
      this.session = JSON.parse(userSessionString);
      this.profileId = this.session.profileId;
      if (id == this.session.profileId) {
        this.canEdit = true;
      }
    });
    
  }

  handleSearch(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    const query = inputElement.value.trim();

    if (query.length < 2) {
      this.locationSuggestions = [];
      return;
    }

    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.fetchNominatimSuggestions(query);
    }, 250);
  }

  fetchNominatimSuggestions(query: string): void {
    fetch(`https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&limit=5&q=${encodeURIComponent(query)}`)
      .then((response) => response.json())
      .then((data) => {
        this.locationSuggestions = data.map((item: any) => ({
          display_name: item.display_name,
          city: item.address.county,
          country: item.address.country,
        }));
      })
      .catch((error) => console.error('Error fetching Nominatim data:', error));
  }

  selectSuggestion(suggestion: any): void {
    this.locationDisplay = `${suggestion.city}, ${suggestion.country}`
    this.updateProfile.patchValue({
      location: {
        city: suggestion.city,
        country: suggestion.country,
      },
    });
    this.locationSuggestions = [];
  }
  
  signOut() {
    localStorage.removeItem('session');
    localStorage.removeItem('profile');
    localStorage.removeItem('currentUser');
    this.router.navigate(['/login']);
  }

  updateProfilePic(event: any) {
    let input = event.target.files[0];
    let dialogRef = this.dialog.open(ImageCropComponent, {
      data: { file: input },
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.croppedImage = result;

      const formdata = new FormData();
      formdata.append('file', this.croppedImage);
      this.spinner = true;
      setTimeout(() => {
        this.apiHelper
          .post(formdata, ApiEndPoints.profileEdit)
          .subscribe((response) => {
            this.userDetails = response.data;
            this.taskService.updateUserDetails(response.data);

            this.spinner = false;
          });
      }, 100);
      event.target.value = null;
    });
  }

  onCancelClick() {
    if (this.currentEditCourse) {
      this.currentEditCourse.isEditMode = false;
      this.currentEditCourse = null;
      this.userProjectImage;
      this.userProjectPreviewImage = '';
    }
    this.addForm.reset({});
  }

  onAddSubmit(recordName: string, record: string) {
    if (!this.addForm.dirty) {
      return alert('no value has been added');
    }

    this.addForm.get('name')?.setValue(recordName);
    this.apiHelper
      .post(this.addForm.value, ApiEndPoints.profileRecordCreate)
      .subscribe((response) => {
        if (!this.recordInfo[recordName]) {
          this.recordInfo[recordName] = [];
        }
        this.recordInfo[recordName].push(response.data);
      });
    this.recordAddInfo[record] = false;
    this.addForm.reset({});
  }

  onEditSubmit(id: string, recordName: string) {
    this.addForm.get('name')?.setValue(recordName);
    this.apiHelper
      .post(
        { id: id, data: this.addForm.value },
        ApiEndPoints.profileRecordUpdate
      )
      .subscribe((response) => {
        if (!this.recordInfo[recordName]) {
          this.recordInfo[recordName] = [];
        }
        let recordeInfoIndex = this.recordInfo[recordName].findIndex(
          (item: any) => item.id === id
        );

        if (recordeInfoIndex !== -1) {
          this.recordInfo[recordName][recordeInfoIndex] = response.data;
          this.recordInfo[recordName][recordeInfoIndex].isEditMode = false;
        }
      });
  }

  formatDateV2(date: any) {
    let newDate = new Date(date);
    return newDate.toJSON().split('T')[0];
  }

  formatDateToMonth(date: any) {
    if (!date) {
      return;
    }
    let newDate = new Date(date);
    return newDate.toISOString().slice(0, 7);
  }

  onEditClick(course: any) {
    this.onCancelClick();
    this.recordAddInfo = {
      courseAdd: false,
      projectAdd: false,
      achievementAdd: false,
      networkAdd: false,
      languageAdd: false,
      roleAdd: false,
      recommendationAdd: false,
    };
    this.currentEditCourse = course;
    this.currentEditCourse.isEditMode = true;

    if (this.currentEditCourse.isEditMode) {
      this.addForm.patchValue(this.currentEditCourse);
      this.addForm
        .get('date1')
        ?.patchValue(this.formatDateToMonth(this.currentEditCourse.date1));
      this.addForm
        .get('date2')
        ?.patchValue(this.formatDateToMonth(this.currentEditCourse.date2));
      // this.currentEditCourse.isEditMode = false;
    }
    this.openModal('#exampleModal');
  }

  categorizeByKey(objectArray: any[], key: string) {
    return objectArray.reduce((result: any, currentItem: any) => {
      const category = currentItem[key];

      if (!result[category]) {
        result[category] = [];
      }

      result[category].push(currentItem);
      return result;
    }, {});
  }

  sortByDate(recordDetails: any) {
    recordDetails.sort(
      (a: any, b: any) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime()
    );
  }

  formatDate(isoString: Date) {
    const date = new Date(isoString);
    let options: {} = {
      year: 'numeric',
      month: 'short',
    };

    return date.toLocaleDateString('en-US', options);
  }

  onToggle(condition: string) {
    if (this.currentEditCourse) {
      this.currentEditCourse.isEditMode = false;
    }
    this.currentEditCourse = null;

    this.addForm.reset({});
    this.recordAddInfo[condition] = !this.recordAddInfo[condition];
  }

  onSave() {
    this.apiHelper
      .post(this.updateProfile.value, ApiEndPoints.profileEdit)
      .subscribe((response) => {
        this.userDetails = response.data;
        this.profileEdit = !this.profileEdit;
        this.locationDisplay = `${this.userDetails.location.city}, ${this.userDetails.location.country}`;
      });
  }

  onProfileToggle(value: boolean) {
    this.profileEdit = !value;
    if (this.profileEdit) {
      this.updateProfile.patchValue(this.userDetails);
    } else {
      this.updateProfile.reset();
    }
  }

  responseDetail: any;
  recommendationAdd() {
    this.apiHelper
      .post({ id: this.session.profileId }, ApiEndPoints.profileGet)
      .subscribe((response) => {
        this.responseDetail = response.data;
        this.addForm.get('profileId')?.setValue(this.userDetails.id);
        this.addForm.get('json1')?.setValue({
          id: this.responseDetail.id,
          name: this.responseDetail.name,
          pictureFileLocations: this.responseDetail.pictureFileLocations,
        });
        this.onEditModalSubmit('recommendation', '#recommendationForm');
      });
    // this.onModalCancel('#recommendationForm');
  }

  onDeleteClick(id: string, recordName: string) {
    this.apiHelper.post({ id }, ApiEndPoints.profileRecordDelete).subscribe(
      (response: any) => {
        this.recordInfo[recordName] = this.recordInfo[recordName].filter(
          (item: any) => item.id !== id
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onDeleteClickV2() {
    let id = this.currentEditCourse.id;
    this.apiHelper.post({ id }, ApiEndPoints.profileRecordDelete).subscribe(
      (response: any) => {
        let recordName = this.currentEditCourse.name;
        this.recordInfo[recordName] = this.recordInfo[recordName].filter(
          (item: any) => item.id !== id
        );
        this.onCancelClick();
        this.onModalCancel('#deleteModal');
      },
      (error) => {
        console.log(error);
      }
    );
  }

  toggle(value: string) {
    this.apiHelper
      .post(
        {
          hiddenFields: value,
          visiblity: !this.hide,
        },
        ApiEndPoints.profileVisible
      )
      .subscribe((response: any) => {
        this.userDetails = response.data;
        this.hide = this.checkForVisibiliy(value);
      });
  }

  checkForVisibiliy(value: string) {
    if (this.userDetails?.hiddenFields?.includes(value)) {
      return false;
    }
    return true;
  }

  visibility(value: string): boolean {
    if (!this.canEdit) {
      return this.checkForVisibiliy(value);
    }
    return true;
  }

  onItemSelect(event: any, type: string) {
    const configs = this.config[type];
    const selectedItem = event.target.value;
    if (selectedItem && !configs['selectArray'].includes(selectedItem)) {
      configs['selectArray'].push(selectedItem);
      this.updateProfile
        .get(configs['formControlNames'])
        ?.setValue(configs['selectArray']);
    }
    event.target.value = '';
  }

  removeItem(item: string, type: string) {
    const configs = this.config[type];
    configs['selectArray'] = configs['selectArray'].filter(
      (r: any) => r !== item
    );
    this.updateProfile
      .get(configs['formControlNames'])
      ?.setValue(configs['selectArray']);
  }

  isItemSelected(item: string, type: string): boolean {
    const configs = this.config[type];
    return configs['selectArray'].includes(item);
  }

  removeImage() {
    this.apiHelper
      .post({ pictureFileLocations: null }, ApiEndPoints.profileEdit, true)
      .subscribe((response: any) => {
        this.userDetails = response.data;
        this.taskService.updateUserDetails(response.data);
      });
  }

  viewProfilePic(imagegeUrl: any) {
    if (imagegeUrl) {
      this.dialog.open(ImageViewerComponent, {
        data: { file: imagegeUrl },
        width: '500px',
        height: 'auto',
        backdropClass: 'modal-popup',
      });
    }
    return;
  }

  handleKeydown(event: KeyboardEvent, key: string) {
    if (event.key.length === 1) {
      event.preventDefault();
    }
  }

  public remainingWords = 100;
  wordCounter() {
    this.remainingWords = this.addForm.value
      ? 100 - this.addForm.value.text1.split(/\s+/).length
      : 100;
    if (this.remainingWords <= 0) {
      // this.addForm.controls['text1'].disable();
    }
  }

  openModal(modalId: string) {
    ($(modalId) as any).modal('show');
  }

  closeModal(modalId: string) {
    ($(modalId) as any).modal('hide');
  }

  onEditModalClick(course: any, modalName: string, type: string) {
    this.onCancelClick();
    this.onRemovePhoto();
    if (type === 'edit') {
      this.currentEditCourse = course;
      this.currentEditCourse.isEditMode = true;
      if (this.currentEditCourse.isEditMode) {
        this.addForm.patchValue(this.currentEditCourse);
        this.addForm
          .get('date1')
          ?.patchValue(this.formatDateToMonth(this.currentEditCourse.date1));
        this.addForm
          .get('date2')
          ?.patchValue(this.formatDateToMonth(this.currentEditCourse.date2));
        this.userProjectPreviewImage =
          this.currentEditCourse.pictureFileLocation;
      }
    }
    this.openModal(modalName);
  }

  onEditModalSubmit(recordName: string, modalName: string) {
    this.addForm.get('name')?.setValue(recordName);

    if (recordName === 'recommendation') {
      this.apiHelper
        .post({ id: this.session.profileId }, ApiEndPoints.profileGet)
        .subscribe((response) => {
          this.responseDetail = response.data;
          this.addForm.get('profileId')?.setValue(this.userDetails.id);
          this.addForm.get('json1')?.setValue({
            id: this.responseDetail.id,
            name: this.responseDetail.name,
            pictureFileLocations: this.responseDetail.pictureFileLocations,
          });
        });
    }

    if (this.currentEditCourse?.isEditMode) {
      let updateFormData = this.fileUploadService.appendFormData(
        this.addForm.value
      );

      updateFormData.append('file', this.userProjectImage);

      if (this.removeRecordImage) {

        updateFormData.append('pictureFileLocation', '');
      }

      updateFormData.append('id', this.currentEditCourse.id);
      this.apiHelper
        .post(updateFormData, ApiEndPoints.profileRecordUpdate)
        .subscribe((response) => {
          if (!this.recordInfo[recordName]) {
            this.recordInfo[recordName] = [];
          }
          let recordeInfoIndex = this.recordInfo[recordName].findIndex(
            (item: any) => item.id === this.currentEditCourse.id
          );
          if (recordeInfoIndex !== -1) {
            this.recordInfo[recordName][recordeInfoIndex] = response.data;
            this.recordInfo[recordName][recordeInfoIndex].isEditMode = false;
          }

          this.onRemovePhoto();
          this.removeRecordImage = false;
        });
    }

    if (!this.currentEditCourse?.isEditMode) {
      if (!this.addForm.dirty) {
        this.closeModal(modalName);
        return;
      }

      let addFormData = this.fileUploadService.appendFormData(
        this.addForm.value
      );

      addFormData.append('file', this.userProjectImage);
      this.apiHelper
        .post(addFormData, ApiEndPoints.profileRecordCreate)
        .subscribe((response) => {
          if (!this.recordInfo[recordName]) {
            this.recordInfo[recordName] = [];
          }
          this.recordInfo[recordName].push(response.data);
          this.onRemovePhoto();
        });
    }
    this.closeModal(modalName);
  }

  onModalCancel(modelName: string) {
    this.onCancelClick();
    this.removeRecordImage = false;
    this.closeModal(modelName);
  }

  onDeleteModal(recordInfo: any) {
    this.currentEditCourse = recordInfo;
    this.openModal('#deleteModal');
  }
  
  setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>, controlName: string,condition: string) {
   if(condition == "month"){
    const selectedDate = moment({ year: normalizedMonthAndYear.year(), month: normalizedMonthAndYear.month() });
    const formattedDate = selectedDate.format('YYYY-MM');
    this.addForm.get(controlName)?.setValue(formattedDate);
   }
    datepicker.close();
  }
  
  handleInput(event: any, dateFormControl: string) {
    let input = event.target.value;
    let data = input === '' ? null : input;
    this.addForm.get(dateFormControl)?.patchValue(data);
  }
  
  onChange(event: any): void {
    const file: File | null = event.target.files?.[0] || null;

    if (file) {
      this.userProjectImage = file; // Store the single file
      const reader = new FileReader();
      reader.onload = () => {
        this.userProjectPreviewImage = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  onRemovePhoto() {
    this.userProjectImage = '';
    this.userProjectPreviewImage = '';
  }

  onRemoveRecordPhoto() {
    this.removeRecordImage = true;
    this.onRemovePhoto();
  }

  handleLink(url: string) {
    const sanitizedUrl = this.sanitizeUrl(url);
    if (this.isValidUrl(sanitizedUrl)) {
      window.open(sanitizedUrl, '_blank', 'noopener,noreferrer');
    } else {
      alert('Invalid URL!');
    }
  }

  sanitizeUrl(url: string): string {
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      return `https://${url}`;
    }
    return url;
  }

isValidUrl(url: string): boolean {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}
}
export function projDateValidator(pDate:AbstractControl): ValidationErrors | null{
  const projectDate=pDate.value;
  const regex = /^\d{4}-\d{2}$/;

  if (!regex.test(projectDate)) {
    return { invalidProjectDate: true };
  }

  // const chosenDate = new Date(`${projectDate}-01`);

  // const currDate = new Date();
  // currDate.setDate(1);
  // if (chosenDate<currDate){
  //   return { invalidProjectDate: true };
  // }

  return null;
}

export function linkValidator(link: AbstractControl): ValidationErrors | null {
  const url = link.value;
  if (url && !url.startsWith('https://')) {

    return { invalidHttps: true };
  }
  return null;
}


